module.exports = __webpack_public_path__ + "img/avatar7.4953adec.svg";